/* eslint-disable max-len */
const RV_STORAGE_DATA = [
	{
		heading: "RV Storage",
		description:
			"Avid campers often invest in their own RVs in order to take weekend outings to the next level. These homes-on-wheels have the ability to make camping a luxurious experience and bring families closer together. However, owning a camper does come with its share of difficulties—like finding enough room for something of that size at home.",
		description2:
			"Fortunately, self storage facilities across the country provide outdoor RV storage for those who want to free up some driveway space and still have easy access to their recreational vehicles.",
		level: 2	
	},
	{
		heading: "How much does RV storage cost?",
		subHeadings: [
			{
				title: "The average monthly cost to store an RV is about $130.",
				desc: "A lot of factors can influence your RV storage cost. The price at a facility for RV storage depends largely on location and amenities, such as sewage dump stations. RV storage prices also vary depending on local supply and demand which can fluctuate depending on the time of year."
			},
			{
				// title: "The average monthly cost",
				desc: "Finally, the size and type of storage space you need for your RV will impact the cost. The bigger your RV, the more space you need and the more it will cost you. You can always save money storing your RV outdoors, but it will be at the mercy of the elements."
			}
		],
		points: [
			{
				title: "Outdoor parking spaces (starting between $30-$50 a month up to $100+): ",
				desc: "Some facilities will have gravel lots while others will have a paved parking lot. If you are looking for cheap RV storage, save money with a gravel lot. parking in paved lots is better for your camper, but might cost more. Cost will correlate with the size of your RV, so expect to pay more for a Class A motorhome than you would for a Class B or small travel trailer."
			},
			{
				title: "Enclosed RV storage (starting between $50-$125 a month and up to $450+): ",
				desc: "Indoor RV storage provides the best protection. If you want to have your RV protected from the winter weather, heated RV storage can cost anywhere from $100 to $450 a month. Again, prices will correlate with the size of your RV, as well as the amenities offered."
			}
		],
		description3:
			"Some facilities offer premium services, such as valet parking, battery charging, sewage dumping, and more, which will lead to higher rates but may be worth the investment. The convenience of doing everything at one place can be invaluable, and they can also increase the running life of your RV.",
		level: 3
	},
	{
		heading: "Understanding RV Unit Sizes",
		description:
			"RVs come in a wide range of sizes, so you have to be aware of that when looking for RV storage. Parking spots at storage facilities may vary in size, too, so it's important to know if your RV will fit. Here are the different classes of RVs and the storage sizes they require:",
		points: [
			{
				title: "Class A Motorhome (40 feet and up): ",
				desc: " If you have a Class A motorhome, you'll need a fairly large parking spot or storage unit to store your RV. The amount of space required could be up to 40 feet long to accommodate the largest of Class A motorhomes. In order to store one indoors, it would likely have to be at a special RV storage facility."
			},
			{
				title: "Class B Motorhome (25 feet and up): ",
				desc: "Class B motorhome owners won't need as large of a parking spot or unit as those with Class A motorhomes. A Class B motorhome can be up to 17 or 19 feet long, so you'll need at least that much space for storage."
			},
			{
				title: "Class C Motorhome (30 feet and up): ",
				desc: "Class C motorhomes are also fairly long so you'll need to be sure you have a space at least 30 feet in length to be able to store this type of RV. Usually, these will require a specialized facility for indoor storage as well."
			}
		],
		subHeadings2: [
			{
				title: "RV Storage Unit Sizes",
				desc: "Most facilities cannot accommodate indoor RV storage unless they’re built for that specific purpose. RVs can be up to 13.5 feet in height, which isn’t available at a standard facility, so make sure you have proper clearance if you plan to store indoors."
			}
		],
		level: 3
	},
	{
		heading: "Types of RV storage",
		description:
			"Another thing to consider is whether or not you want to protect your RV from the elements, which may be recommended in a region with harsh winters. While most facilities have outdoor RV storage, some may offer indoor or covered RV storage as well.",
		points: [
			{
				title: "Outdoor - ",
				desc: "Outdoor RV storage is the most common choice and the most affordable. If weather isn't much of a concern in your area, Outdoor storage can be a great option for your RV."
			},
			{
				title: "Covered - ",
				desc: "There are some storage facilities that offer covered storage for RVs and trailers. These provide additional protection from the elements, such as sun, hail, and snow."
			},
			{
				title: "Indoor - ",
				desc: "Indoor RV storage is the most expensive option for storing your motorhomes or trailers, but it's worth it in certain climates. If you experience heavy snowfall or severe storms in your region, protecting your RV with indoor storage will save you money on repairing damages."
			}
		],
		level: 3
	},
	{
		heading: "Reasons for using RV storage",
		description:
			"There are many great reasons for using self storage for your RV. Not only is RV storage an affordable and convenient option, it has many other benefits as well.",
		subHeadings: [
			{
				title: "Free space",
				desc: "RVs come in a wide range of sizes, varying from compact 5th wheels trailers to large motorhomes. The largest, the Class A motorhome, can average between 25 to 40 feet long. The large size of most campers can easily take up an entire driveway or cause problems with home storage. Using RV or trailer storage allows you to take back some of that space."
			},
			{
				title: "Neighborhood HOAs",
				desc: "A lot of neighborhoods have specific HOAs that prohibit the parking of RVs or trailers on driveways for long periods of time. There are even rules against parking one along the side of your home in some neighborhoods depending on the regulations of your homeowners association. Camper storage allows you to follow HOA rules and still own the camping vehicle of your dreams."
			},
			{
				title: "Protection/security",
				desc: "It can be dangerous to leave an RV or trailer in front of your house, as they're often magnets for vandalism and theft. Using RV storage can provide an added level of security for your favorite camper. Storage facilities often have high fences, gated access, and even video surveillance."
			},
			{
				title: "Convenient location",
				desc: "With so many storage facilities spread throughout the nation, you can easily find a location that's convenient for you. Whether that means it's close to your home or closer to the highway, you can choose a storage facility that makes hitting the open road easier than ever."
			}
		],
		level: 3
	},
	{
		heading: "RV Storage FAQs",
		subHeadings: [
			{
				title: "How do I prepare my RV for winter storage?",
				desc: "There are many things you can do to prepare your RV for winter storage, all of which will depend on if you're storing outdoors or indoors. For outdoor storage, you'll want to be especially careful, as the weather can damage your RV over long periods of time. Take a look at some of the most important preparation steps below:"
			}
		],
		points: [
			{
				desc: "washing your RV"
			},
			{
				desc: "lubricating moving parts"
			},
			{
				desc: "covering tires"
			},
			{
				desc: "cover with a breathable tarp"
			},
			{
				desc: "use moisture-absorbent material on the inside to prevent mold"
			},
			{
				desc: "disconnecting propane tanks"
			},
			{
				desc: "removing perishables and valuables"
			},
			{
				desc: "proofing for pests"
			}
		],
		heading2: "How do I find RV storage near me?",
		description3:
			'Searching for the best price on storage solutions for your RV used to be a hassle involving calling several locations and asking about their pricing. Searching on the web for "indoor RV storage near me" or "trailer storage near me" can also take a lot of time and lead you in different directions.',
		description4:
			"The best way to find RV storage parking in your area is to simply search on Storage.com. In addition to thousands of storage units online, Storage.com helps RVers find the right RV storage unit or parking spot at the best price.",
		level: 3
	},
	{
		heading: "Popular Cities For RV Storage",
		popularCities: true,
		level: 3
	}
];

export { RV_STORAGE_DATA };
